import React from "react";
import { Template as TabFeatureAttributeBlockTemplate } from "tsi-common-react/src/templates/TabFeatureAttributeBlockTemplate";

import { templates } from "@reactivated";

// Use tempurpedic provider with the common component
export const Template = (props: templates.TabFeatureAttributeBlockTemplate) => {
    return <TabFeatureAttributeBlockTemplate {...props} />;
};
